import { render, staticRenderFns } from "./TransactionHistoryLoading.vue?vue&type=template&id=2faa0a6f&scoped=true&"
import script from "./TransactionHistoryLoading.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TransactionHistoryLoading.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faa0a6f",
  null
  
)

export default component.exports